import React from 'react';
import { registerIcons, getIcon } from '@fluentui/react';
import { AddRegular, ArrowClockwiseRegular, ArrowDownRegular, ArrowLeftRegular, ArrowMaximizeRegular, ArrowUpRegular, CheckboxUncheckedRegular, CheckmarkRegular, CheckmarkCircleRegular, ChevronDownRegular, ChevronLeftRegular, ChevronRightRegular, ChevronUpRegular, ClockRegular, CodeRegular, DismissRegular, DismissCircleRegular, EyeRegular, EyeOffRegular, FilterRegular, InfoRegular, LinkSquareRegular, ListRegular, LockClosedFilled, LockOpenRegular, MoreHorizontalRegular, NavigationRegular, TextAlignLeftRegular, TextBoldRegular, TextClearFormattingRegular, TextColorRegular, TextFontRegular, TextFontSizeRegular, TextItalicRegular, TextStrikethroughRegular, TextUnderlineRegular, WarningFilled, WarningRegular, HighlightRegular, TextSuperscriptRegular, TextSubscriptRegular, TextIndentDecreaseLtrRegular, TextIndentIncreaseLtrRegular, TextNumberListLtrRegular, TextQuoteFilled, TextAlignCenterRegular, TextAlignRightRegular, ArrowRedoRegular, ArrowUndoRegular, SettingsRegular, SaveRegular, EditRegular, PersonRegular, PhoneLaptopRegular, PeopleCommunityRegular, HomeRegular, HeadsetRegular, PaymentRegular } from '@fluentui/react-icons';
var iconMap = {
    Add: AddRegular,
    AlignCenter: TextAlignCenterRegular,
    AlignLeft: TextAlignLeftRegular,
    AlignRight: TextAlignRightRegular,
    Back: ArrowLeftRegular,
    Bold: TextBoldRegular,
    Cancel: DismissRegular,
    Checkbox: CheckboxUncheckedRegular,
    Checkmark: CheckmarkRegular,
    ChevronDown: ChevronDownRegular,
    ChevronDownMed: ChevronDownRegular,
    ChevronLeft: ChevronLeftRegular,
    ChevronRight: ChevronRightRegular,
    ChevronUp: ChevronUpRegular,
    ChromeClose: DismissRegular,
    ClearFormatting: TextClearFormattingRegular,
    Clock: ClockRegular,
    Code: CodeRegular,
    Completed: CheckmarkCircleRegular,
    Contact: PersonRegular,
    DecreaseIndentLegacy: TextIndentDecreaseLtrRegular,
    Devices: PhoneLaptopRegular,
    Down: ArrowDownRegular,
    Edit: EditRegular,
    ErrorBadge: DismissCircleRegular,
    Filter: FilterRegular,
    Font: TextFontRegular,
    FontColor: TextColorRegular,
    FontSize: TextFontSizeRegular,
    FullScreen: ArrowMaximizeRegular,
    GlobalNavButton: NavigationRegular,
    Group: PeopleCommunityRegular,
    Headset: HeadsetRegular,
    Hide3: EyeOffRegular,
    Highlight: HighlightRegular,
    Home: HomeRegular,
    IncidentTriangle: WarningFilled,
    IncreaseIndentLegacy: TextIndentIncreaseLtrRegular,
    Info: InfoRegular,
    Italic: TextItalicRegular,
    Link: LinkSquareRegular,
    List: ListRegular,
    LockSolid: LockClosedFilled,
    More: MoreHorizontalRegular,
    NumberedList: TextNumberListLtrRegular,
    PaymentCard: PaymentRegular,
    Redo: ArrowRedoRegular,
    Refresh: ArrowClockwiseRegular,
    RightDoubleQuote: TextQuoteFilled,
    Save: SaveRegular,
    Settings: SettingsRegular,
    Strikethrough: TextStrikethroughRegular,
    Subscript: TextSubscriptRegular,
    Superscript: TextSuperscriptRegular,
    Underline: TextUnderlineRegular,
    Undo: ArrowUndoRegular,
    Unlock: LockOpenRegular,
    Up: ArrowUpRegular,
    View: EyeRegular,
    Warning: WarningRegular
};
export var addSvgMapping = function (iconName, SvgIcon) {
    iconMap[iconName] = SvgIcon;
};
export var getSvgIcon = function (iconName) {
    return iconMap[iconName];
};
export var addIconPropsToObject = function (iconObject) {
    var iconName = iconObject === null || iconObject === void 0 ? void 0 : iconObject.iconName;
    if (iconObject && iconName) {
        var SvgIcon = iconMap[iconName];
        if (SvgIcon) {
            var name_1 = createName(iconName);
            iconObject.iconName = name_1;
            registerSvg(name_1, SvgIcon);
        }
    }
};
export var createName = function (name) { return "".concat(name, "svg"); };
export var registerSvg = function (name, SvgIcon) {
    var _a;
    if (!getIcon(name)) {
        registerIcons({
            icons: (_a = {},
                _a[name] = React.createElement(SvgIcon, { style: { transform: 'scale(1.2)' } }),
                _a)
        });
    }
};
//# sourceMappingURL=utilities.js.map